import React from "react";
import { Link } from "react-router-dom";

const Galeri = () => {
  return (
    <section className="py-8 px-8 md:px-16 font-[Quicksand] text-gray-800 leading-relaxed">
      <div className="max-w-6xl mx-auto">
        {/* Judul */}
        <h2 className="text-2xl font-bold text-gray-900 mb-6">
          Gallery & Testimonials
        </h2>

        {/* Galeri Gambar */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mb-12">
          {/* Card 1 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-md">
            <div className="bg-[#F5A19D] text-white px-4 py-2 text-lg font-semibold">
              Coco
            </div>
            <div className="grid grid-cols-2">
              <div className="relative">
                <img
                  src="/assets/images/before.jpg"
                  alt="Coco Before"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 text-center text-white text-sm font-semibold py-1 bg-black/50">
                  Before
                </div>
              </div>
              <div className="relative">
                <img
                  src="/assets/images/after.jpg"
                  alt="Coco After"
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 text-center text-white text-sm font-semibold py-1 bg-black/50">
                  After
                </div>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-md">
            <div className="bg-[#F5A19D] text-white px-4 py-2 text-lg font-semibold">
              PLACEHOLDER 2
            </div>
            <div className="grid grid-cols-2">
              <div className="relative">
                <img
                  src="/assets/images/before.jpg"
                  alt="Dog 2 Before"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 text-center text-white text-sm font-semibold py-1 bg-black/50">
                  Before
                </div>
              </div>
              <div className="relative">
                <img
                  src="/assets/images/after.jpg"
                  alt="Dog 2 After"
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 text-center text-white text-sm font-semibold py-1 bg-black/50">
                  After
                </div>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-md">
            <div className="bg-[#F5A19D] text-white px-4 py-2 text-lg font-semibold">
              PLACEHOLDER 3
            </div>
            <div className="grid grid-cols-2">
              <div className="relative">
                <img
                  src="/assets/images/before.jpg"
                  alt="Dog 3 Before"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 text-center text-white text-sm font-semibold py-1 bg-black/50">
                  Before
                </div>
              </div>
              <div className="relative">
                <img
                  src="/assets/images/after.jpg"
                  alt="Dog 3 After"
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 text-center text-white text-sm font-semibold py-1 bg-black/50">
                  After
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bagian Testimonial */}
        <div className="text-gray-800 space-y-4">
          <p className="text-lg">
            Check out our Google{" "}
            <Link
              to="/feedback"
              className="text-blue-600 hover:text-blue-800 underline-offset-4 hover:underline transition-all"
            >
              Review
            </Link>
          </p>
          <ul className="list-disc list-inside text-base text-gray-700 space-y-2">
            <li>
              “Lovely to deal with and did a great job with my puppy. Highly
              recommend. Easy parking.” – <strong>Dan</strong>
            </li>
            <li>
              “Our mini Schnauzer ‘Luci’ loves going to doggy daycare once a
              week. We also have her groomed at Furlissimo without any problem.
              Very happy with the service.” – <strong>Leanne</strong>
            </li>
            <li>
              “Brilliant service. Rhylee has looked after our Cavoodle since she
              was a puppy and has always provided a great cut.” –{" "}
              <strong>Mike</strong>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Galeri;
